import Vue from 'vue'
import App from './App.vue'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import VueTheMask from 'vue-the-mask'
import 'vueperslides/dist/vueperslides.css'
import VueNoty from 'vuejs-noty'
import 'vuejs-noty/dist/vuejs-noty.css'
import Noty from 'noty';
import jwt from 'jwt-simple'
import 'animate.css/animate.compat.css';
import IdleVue from "idle-vue";
import store from './components/Store'
import router from "@/router";
import Principal from "@/views/Principal"

Vue.config.productionTip = true

Vue.prototype.$globalHost = (Vue.config.productionTip) ? 
    //'https://dev-sistemas.sedatu.gob.mx/Portal-0.0.1-SNAPSHOT': 
    //'https://qa-sistemas.sedatu.gob.mx/Portal-0.0.1-SNAPSHOT': 
    process.env.VUE_APP_GLOBAL_HOST:
    //'https://sistemas.sedatu.gob.mx/Portal-0.0.1-SNAPSHOT': 
      'http://localhost:8080/Portal-0.0.1-SNAPSHOT'

//Inactivity check
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 1200000 //20 minutos
  //idleTime: 9000000000 // 104 días
});

//Instacia vue con los componentes del portal
new Vue({
  beforeCreate: function () {
    console.log(this.$globalHost)
  },
  router,
  store,
  render: h => h(App),
}).$mount('#app')

Vue.use(VueTheMask);
Vue.use(Loading);
Vue.use(jwt);
Vue.use(VueNoty)
Vue.component('loading', Loading);


//Funciones globales en VueJS
Vue.mixin({
    methods: {
      alertaTokenFinalizo () {
          var warn = this.$noty.warning(
            "El tiempo de sesión finalizo, ¿Desea continuar en el portal de autoservicio o quiere finalizar su sesión?",
          {
              buttons: [
                Noty.button('Salir', 'btn btn-primary', function () {

                  Principal.methods.refreshOut();
                  warn.close();
                }),
                Noty.button('Continuar', 'btn btn-danger', function () {

                  let token = localStorage.getItem('token').replace('Bearer','').trim();
                  let tokenDecodificado = jwt.decode(token,"8120", "HS512")

                  Principal.methods.refresh(tokenDecodificado.sub, tokenDecodificado.pass);
                  warn.close();

                })
              ],
              type: 'warning',
              layout: 'center',
              theme: 'bootstrap-v4',
              progressBar: false,
              timeout: false,
              modal: true,
              killer: true,
              closeWith: ['button'],
              animation: {
                open: 'animated bounceInDown faster', // Animate.css class names
                close: 'animated bounceOut faster' // Animate.css class names
              }
          });
      },
      llamarAlertaWarining(mensaje) {

				let warn = this.$noty.warning(
					mensaje,
					{
						buttons: [
							Noty.button('Aceptar', 'btn btn-danger', function () {
								warn.close();
							}),
						],
						type: 'warning',
						layout: 'center',
						theme: 'bootstrap-v4',
						progressBar: false,
						timeout: false,
						modal: true,
						killer: true,
						closeWith: ['button'],
						animation: {
							open: 'animated bounceInDown faster', // Animate.css class names
							close: 'animated bounceOut faster' // Animate.css class names
						}
					}
				);
      },
      llamarAlertaError(mensaje) {

        this.$noty.error(
          mensaje,
          {
            type:'error',
            layout:'topRight',
            theme: 'bootstrap-v4',
            killer: true,
            progressBar: false,
						timeout: false,
            animation: {
							close: 'animated bounceOut faster' // Animate.css class names
            }
          }
        )
      },
      procesarErrorYdesplegarMensaje(objError, mensaje) {

        if (objError == 'Error: Network Error') {
          this.llamarAlertaError('La conexión ha fallado, revise su conexión a internet y vuelva a intentarlo')
        } else if (objError.response.status === 403) {
          this.alertaTokenFinalizo();
        } else {
          this.llamarAlertaError(mensaje)
        }
      }
    }
})


Vue.directive('uppercase', {
	update (el) {
		el.value = el.value.toUpperCase()
	},
})